import { useCurrentRole } from './useCurrentRole';

export const useCurrentPharmacy = () => {
  const currentRole = useCurrentRole();

  if (!currentRole || currentRole.resource_type !== 'Pharmacy') {
    return null;
  }

  return currentRole.resource;
};
